// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--jXwKG","all-category":"_1410bfd27b--all-category--i9Ql4","icon":"_1410bfd27b--icon--Mo2XU","text":"_1410bfd27b--text--PkWkk"};